import React from 'react'
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/styles';
import { observer } from 'mobx-react'
import MMap from '../MMap'
import Content from '../Content'
import authStore from '../../authStore'
import { Redirect } from "react-router-dom";

const classes = {
    fab: {
        backgroundColor: '#b14d9b',
        color: 'white',
        zIndex: 401,
        fontSize: '1.4rem'
    },
    footer: {
        position: 'absolute',
        bottom: '2rem',
        right: '0',
        left: '0',
        textAlign: 'center',
        pointerEvents: 'all'
    },
}


const Home = observer(class Home extends React.Component {
    constructor() {
        super()

        this.state = {
            panel_mode: null,
            panel_params: null,
            redirectToConnect: false,
        }

        
    }

    async onLocationClicked(location, location_id) {
        console.log("##Home Component", "onLocationClicked")
        this.setState({ panel_mode: 'location', panel_params: { location: location, location_id: location_id } })
    }

    componentDidMount() {
        const headerElem = document.getElementById('header');
        if (headerElem) {
            this.setState({ height: window.innerHeight - headerElem.offsetHeight })
        }
    }

    askToReport(params) {
        console.log("##Home Component", "askToReport")
        const user = authStore.user.get()
        if (user) {
            this.setState({ panel_mode: 'report', panel_params: params })
        }
        else {
            this.setState({ redirectToConnect: true })
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                {this.state.height  ? <div>
                    <MMap
                        store={this.props.store}
                        zoom={15} center={this.props.store.map_center}
                        onLocationClicked={function (location, location_id) { this.onLocationClicked(location, location_id) }.bind(this)}
                        onMapClicked={function (latlng) {
                            this.askToReport({ latlng: latlng })
                        }.bind(this)} />
                    <div className={classes.footer}>
                        {this.state.redirectToConnect ? <Redirect to="/connect"></Redirect> :
                            <Fab className={classes.fab} variant="extended" aria-label="like" onClick={function () { this.askToReport() }.bind(this)}>
                                אני רוצה לדווח על מצב הניקיון
                </Fab>}


                    </div>
                    <Content mode={this.state.panel_mode} params={this.state.panel_params} /> </div> : null}
            </div>
        )
    }
})

export default withStyles(classes)(Home);

